import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = ({ isDesktop, isAdminLoggedIn, setIsAdminLoggedIn }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  // Atajos de teclado para desktop
  useEffect(() => {
    if (!isDesktop) return;

    const handleKeyDown = (e) => {
      if (e.ctrlKey) {
        switch(e.key) {
          case '1':
            e.preventDefault();
            navigate('/');
            break;
          case '2':
            e.preventDefault();
            navigate('/registro');
            break;
          case '3':
            e.preventDefault();
            navigate('/scanner');
            break;
          case '4':
            e.preventDefault();
            navigate('/admin');
            break;
          case '5':
            e.preventDefault();
            navigate('/gafetes');
            break;
          case '6':
            e.preventDefault();
            navigate('/portal');
            break;
          default:
            break;
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isDesktop, navigate]);

  const handleLogout = () => {
    setIsAdminLoggedIn(false);
    localStorage.removeItem('adminToken');
    localStorage.removeItem('isAdminLoggedIn');
    navigate('/');
  };

  return (
    <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4">
      <div className="glass-card rounded-2xl px-6 py-3 flex items-center justify-between border-slate-800/80 shadow-xl bg-slate-900/60 backdrop-blur-md">
        <div className="flex items-center gap-8">
          <div className="flex-shrink-0 cursor-pointer" onClick={() => navigate('/')}>
            <span className="text-xl font-extrabold tracking-wider bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-blue-500 to-indigo-500">
              QRPeña
            </span>
          </div>
          <div className="hidden md:block">
            <div className="flex items-center space-x-2">
              <button
                onClick={() => navigate("/")}
                className={`px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                  currentPath === "/"
                    ? "bg-slate-800/85 text-cyan-400 border border-slate-700/50 shadow-inner"
                    : "text-slate-300 hover:bg-slate-800/40 hover:text-white"
                } relative group`}
              >
                Inicio
                {isDesktop && (
                  <span className="absolute -bottom-7 left-1/2 -translate-x-1/2 scale-75 opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-slate-900 border border-slate-800 px-1.5 py-0.5 rounded text-[10px] text-slate-400 flex gap-1 pointer-events-none z-50">
                    <kbd>Ctrl</kbd>+<kbd>1</kbd>
                  </span>
                )}
              </button>

              <button
                onClick={() => navigate("/registro")}
                className={`px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                  currentPath === "/registro"
                    ? "bg-slate-800/85 text-cyan-400 border border-slate-700/50 shadow-inner"
                    : "text-slate-300 hover:bg-slate-800/40 hover:text-white"
                } relative group`}
              >
                Registro
                {isDesktop && (
                  <span className="absolute -bottom-7 left-1/2 -translate-x-1/2 scale-75 opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-slate-900 border border-slate-800 px-1.5 py-0.5 rounded text-[10px] text-slate-400 flex gap-1 pointer-events-none z-50">
                    <kbd>Ctrl</kbd>+<kbd>2</kbd>
                  </span>
                )}
              </button>

              <button
                onClick={() => navigate("/scanner")}
                className={`px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                  currentPath === "/scanner"
                    ? "bg-slate-800/85 text-cyan-400 border border-slate-700/50 shadow-inner"
                    : "text-slate-300 hover:bg-slate-800/40 hover:text-white"
                } relative group`}
              >
                Escáner
                {isDesktop && (
                  <span className="absolute -bottom-7 left-1/2 -translate-x-1/2 scale-75 opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-slate-900 border border-slate-800 px-1.5 py-0.5 rounded text-[10px] text-slate-400 flex gap-1 pointer-events-none z-50">
                    <kbd>Ctrl</kbd>+<kbd>3</kbd>
                  </span>
                )}
              </button>

              <button
                onClick={() => navigate("/admin")}
                className={`px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                  currentPath === "/admin"
                    ? "bg-slate-800/85 text-cyan-400 border border-slate-700/50 shadow-inner"
                    : "text-slate-300 hover:bg-slate-800/40 hover:text-white"
                } relative group`}
              >
                Admin
                {isDesktop && (
                  <span className="absolute -bottom-7 left-1/2 -translate-x-1/2 scale-75 opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-slate-900 border border-slate-800 px-1.5 py-0.5 rounded text-[10px] text-slate-400 flex gap-1 pointer-events-none z-50">
                    <kbd>Ctrl</kbd>+<kbd>4</kbd>
                  </span>
                )}
              </button>

              <button
                onClick={() => navigate("/gafetes")}
                className={`px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                  currentPath === "/gafetes"
                    ? "bg-slate-800/85 text-cyan-400 border border-slate-700/50 shadow-inner"
                    : "text-slate-300 hover:bg-slate-800/40 hover:text-white"
                } relative group`}
              >
                Gafetes
                {isDesktop && (
                  <span className="absolute -bottom-7 left-1/2 -translate-x-1/2 scale-75 opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-slate-900 border border-slate-800 px-1.5 py-0.5 rounded text-[10px] text-slate-400 flex gap-1 pointer-events-none z-50">
                    <kbd>Ctrl</kbd>+<kbd>5</kbd>
                  </span>
                )}
              </button>

              <button
                onClick={() => navigate("/portal")}
                className={`px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                  currentPath === "/portal"
                    ? "bg-slate-800/85 text-indigo-400 border border-slate-700/50 shadow-inner"
                    : "text-slate-300 hover:bg-slate-800/40 hover:text-white"
                } relative group`}
              >
                Portal
                {isDesktop && (
                  <span className="absolute -bottom-7 left-1/2 -translate-x-1/2 scale-75 opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-slate-900 border border-slate-800 px-1.5 py-0.5 rounded text-[10px] text-slate-400 flex gap-1 pointer-events-none z-50">
                    <kbd>Ctrl</kbd>+<kbd>6</kbd>
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-4">
          {isDesktop && (
            <span className="hidden lg:inline text-xs text-slate-400 font-medium tracking-wide">
              Negocios Peña E.I.R.L.
            </span>
          )}
          {isAdminLoggedIn && (
            <button
              onClick={handleLogout}
              className="px-4 py-1.5 rounded-xl text-xs font-semibold bg-rose-500/10 hover:bg-rose-500/20 text-rose-400 border border-rose-500/25 transition-all duration-200"
            >
              Cerrar Sesión
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;